import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SHEET_GIDS } from "../api/sheetsApi";

export default function EditSheet() {
  const { tabKey } = useParams();
  const navigate = useNavigate();
  
  const sheetInfo = SHEET_GIDS[tabKey];
  const gid = sheetInfo ? sheetInfo.gid : null;
  const tabName = sheetInfo ? sheetInfo.name : "Unknown Tab";
  const baseUrl = process.env.REACT_APP_GOOGLE_SHEET_EDIT_URL;

  const BACK_ROUTES = {
    mainDashboard: "/dashboard",
    academics: "/academics",
    transport: "/transport",
    humanResources: "/hr",
    hyderabad: "/branches/hyderabad",
    kvr: "/branches/kvr-campus",
    perumbakkam: "/branches/perumbakkam",
    thirumudivakkam: "/branches/thirumudivakkam",
    thiruvanmiyur: "/branches/thiruvanmiyur",
    bestSchool: "/best-school",
  };

  if (!baseUrl) {
    return (
      <div className="flex h-[calc(100vh-100px)] w-full flex-col items-center justify-center p-8 text-center text-gray-500">
        <p>Edit URL is not configured. Please add REACT_APP_GOOGLE_SHEET_EDIT_URL to your .env file.</p>
      </div>
    );
  }

  if (!gid) {
    return (
      <div className="flex h-[calc(100vh-100px)] w-full flex-col items-center justify-center p-8 text-center text-gray-500">
        <p>Invalid Sheet Tab specified.</p>
      </div>
    );
  }

  const iframeSrc = `${baseUrl}?rm=minimal#gid=${gid}`;

  return (
    <div className="flex h-[calc(100vh-2rem)] w-full flex-col bg-white p-4 rounded-2xl shadow-sm">
      <div className="mb-4 flex items-center justify-between border-b pb-4">
        <div className="flex items-center gap-4">
          <button 
            onClick={() => {
              const backRoute = BACK_ROUTES[tabKey] || "/dashboard";
              navigate(backRoute);
            }}
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-gray-600 transition hover:bg-gray-200"
            title="Go Back"
          >
            <ArrowLeft size={20} />
          </button>
          <div>
            <h1 className="text-xl font-bold text-gray-800">Edit Data - {tabName}</h1>
            <p className="text-sm text-gray-500">
              Make changes directly. Changes are saved automatically.
            </p>
          </div>
        </div>
        
        <a 
          href={iframeSrc}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white transition hover:bg-blue-700 shadow-sm flex items-center gap-2"
        >
          Open in New Tab
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
        </a>
      </div>
      <div className="flex-1 overflow-hidden rounded-xl border border-gray-200">
        <iframe
          src={iframeSrc}
          title="Google Sheet Editor"
          className="h-full w-full border-none"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
}
